module.exports = __webpack_public_path__ + "img/luis-galarza.866788bd.jpg";